import { technologyResources } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { ITechnologyResourceData, ITechnologyResources } from "../../models/master/technologyResource";

export default new (class TechnologyResourceService {
  public getTechnologyResource = async (
    id: number
  ): Promise<IApiResponse<ITechnologyResourceData>> => {
    try {
      let endPoint = urlBinder(technologyResources.GET_TECHNOLOGY_RESOURCE_BLOCK, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ITechnologyResourceData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ITechnologyResourceData>;
      } else {
        throw error;
      }
    }
  };

  public getTechnologyResources = async (
    configUserRole?: number,
    pageBlockId?: number,
    collegeId?: number,
    departmentId?: number,
    noOfItems?: number,
  ): Promise<IApiResponse<Array<ITechnologyResources>>> => {
    try {
      let endPoint = urlBinder(technologyResources.GET_ALL_TECHNOLOGY_RESOURCE_BLOCKS, [configUserRole, pageBlockId, collegeId, departmentId, noOfItems]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<ITechnologyResources>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<ITechnologyResources>>;
      } else {
        throw error;
      }
    }
  };

  public createTechnologyResource = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = technologyResources.CREATE_TECHNOLOGY_RESOURCE_BLOCK;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateTechnologyResource = async (
    data: any, id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(technologyResources.UPDATE_TECHNOLOGY_RESOURCE_BLOCK, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateTechnologyResourcePriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = technologyResources.UPDATE_TECHNOLOGY_RESOURCE_BLOCK_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteTechnologyResource = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(technologyResources.DELETE_TECHNOLOGY_RESOURCE_BLOCK, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
